import { render, staticRenderFns } from "./TransactionActionConfirmationModal.vue?vue&type=template&id=1a10e6be&"
import script from "./TransactionActionConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./TransactionActionConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionActionConfirmationModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports